var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1132_7133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6253 22.7581L48.1973 21.3301L34.9698 34.5576C33.3163 36.2111 30.5355 36.2111 28.8821 34.5576L15.6545 21.4052L14.2266 22.8332L24.0721 32.6787L14.2266 42.5242L15.6545 43.9522L25.5 34.1067L27.4541 36.0608C28.6566 37.2633 30.2349 37.9397 31.8884 37.9397C33.5418 37.9397 35.1201 37.2633 36.3226 36.0608L38.2767 34.1067L48.1222 43.9522L49.5502 42.5242L39.7046 32.6787L49.6253 22.7581Z",
    fill: "#18DF80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8434 46.5073H17.1566C15.428 46.5073 14 45.0793 14 43.3507V22.1566C14 20.428 15.428 19 17.1566 19H46.8434C48.572 19 50 20.428 50 22.1566V43.3507C50 45.0793 48.572 46.5073 46.8434 46.5073ZM17.0814 21.0292C16.4802 21.0292 16.0292 21.4802 16.0292 22.0814V43.2756C16.0292 43.8768 16.4802 44.3278 17.0814 44.3278H46.7683C47.3695 44.3278 47.8205 43.8768 47.8205 43.2756V22.0814C47.8205 21.4802 47.3695 21.0292 46.7683 21.0292H17.0814Z",
    fill: "#18DF80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1132_7133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.9311ea2110006ba53b890b8b9f8781ad.svg";
export { ForwardRef as ReactComponent };